<ngx-extended-pdf-viewer
  [src]="pdfUrl"
  [contextMenuAllowed]="false"
  [showSecondaryToolbarButton]="false"
  [showSidebarButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="false"
  [showDownloadButton]="false"
  [sidebarVisible]="false"
  (pdfLoaded)="isLoaded = true"
  (pdfLoadingFailed)="isLoaded = true"
></ngx-extended-pdf-viewer>
<mat-icon mat-dialog-close>clear</mat-icon>
@if (!isLoaded) {
  <div class="loader">
    <mat-spinner></mat-spinner>
  </div>
}
